import React, { useState } from "react";
import { WrapperSeamless } from "layout-components";
import Table from "components/tables/table";
import { useTranslation } from "localization/translation";
import { BUTTONS_TYPE } from "Constants";
import { StyledButton } from "components";
import dragIcon from "assets/images/dragIcon.svg";


export const FeaturesInformation = ({
  features,
  editHandler,
  deleteHandler,
  showSecondButton,
  secondButtonText,
  handlerSecondButton,
  showEditButton = false,
  showActiveButton = false,
  loadingDelete,
  actionFeatureStatusChange,
  loadingChangeFeatureStatus,
  reorderEnabled = false,
  setFeatures,
  onReorder,
}) => {
  const translation = useTranslation();
  const [activateDrag, setActivateDrag] = useState(false);
  const [dragElement, setDragElement] = useState(null);

  const handleDragEnd = () => {
    setActivateDrag(false);
    setDragElement(null);
    onReorder();
  };

  const featureCells = (feature) => (
    <>
      {reorderEnabled && (
        <td className="text-left px-3">
          <span
            className="drag-icon-field"
            onMouseDown={() => {
              setActivateDrag(true);
              setDragElement(feature.id);
            }}
            onMouseUp={() => {
              setActivateDrag(false);
              setDragElement(null);
            }}
          >
            <span className="drag-icon-background"></span>
            <img
              src={dragIcon}
              alt={translation.display_order}
              className="drag-icon"
            />
          </span>
        </td>
      )}
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{feature.name_hy}</div>
      </td>
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{feature.name_en}</div>
      </td>
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{feature.name_ru}</div>
      </td>
      <td className="text-right px-3">
        <div className="font-size-sm align-box-row">
          <div className="delete_filed">
            <StyledButton
              className={BUTTONS_TYPE.delete}
              name={translation.delete}
              disabled={loadingDelete}
              onClick={() => deleteHandler(feature.id)}
            />
          </div>
          {
            !!showActiveButton && (
              <div className="activate_field ml-2">
                <StyledButton
                  className={feature.included ? BUTTONS_TYPE.deactive : BUTTONS_TYPE.active}
                  name={feature.included ? translation.deactivate : translation.activate}
                  onClick={() => actionFeatureStatusChange(feature.id)}
                  disabled={loadingChangeFeatureStatus}
                />
              </div>
            )
          }
          {
            !!showEditButton && (
              <div className="activate_field ml-2">
                <StyledButton
                  className={BUTTONS_TYPE.edit}
                  name={translation.edit}
                  onClick={() => {
                    editHandler(feature.id)
                  }}
                />
              </div>
            )
          }
        </div>
      </td>
    </>
  );

  const rows = features?.map((feature) =>
    reorderEnabled ? (
      <React.Fragment key={feature.id}>
        {featureCells(feature)}
      </React.Fragment>
    ) : (
      <tr
        key={feature.id}
        className="px-2 py-2 m-2 my-3 font-weight-bold position-relative"
      >
        {featureCells(feature)}
      </tr>
    )
  );

  return (
    <WrapperSeamless>
      <Table
        fields={
          <>
            {reorderEnabled && (
              <th className="text-left px-3">
                <span className="mr-3">{translation.display_order}</span>
              </th>
            )}
            <th className="text-left px-3">
              <span className="mr-3">{translation.name_hy || 'Name (Armenian)'}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.name_en || 'Name (Armenian)'}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.name_ru || 'Name (Armenian)'}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.status}</span>
            </th>
          </>
        }
        noDrag={!reorderEnabled}
        title={translation.feature}
        items={features}
        setItems={setFeatures}
        rows={rows}
        actions={false}
        userPage
        activateDrag={activateDrag}
        dragElement={dragElement}
        dragEnd={handleDragEnd}
        showSecondButton={showSecondButton}
        secondButtonText={secondButtonText}
        handlerSecondButton={handlerSecondButton}
      />
    </WrapperSeamless>
  );
};
